const house = [
    {
        path: '/data/map',
        name: 'dataMap',
        component: () => import('@/view/data/map'),
    }
]
export default house